import React from "react";

/**
 * Carte stylisée de l'Europe : nuage de points + marqueurs de destinations.
 * Purement décorative (pas de données géographiques exactes).
 */

const DOTS = [
  [18, 62], [24, 55], [30, 48], [36, 44], [42, 40], [48, 38], [54, 36],
  [60, 34], [66, 36], [72, 40], [78, 44], [84, 50], [22, 70], [28, 64],
  [34, 58], [40, 52], [46, 48], [52, 46], [58, 44], [64, 46], [70, 50],
  [76, 54], [82, 60], [26, 78], [32, 72], [38, 66], [44, 62], [50, 58],
  [56, 56], [62, 56], [68, 60], [74, 64], [80, 70], [30, 86], [36, 80],
  [42, 76], [48, 72], [54, 70], [60, 68], [66, 70], [72, 74], [40, 30],
  [46, 28], [52, 26], [58, 26], [64, 28], [34, 34], [70, 30],
];

const MARKERS = [
  [30, 40], [45, 33], [58, 30], [70, 42], [24, 52], [38, 48], [50, 44],
  [63, 48], [76, 52], [33, 62], [46, 58], [59, 62], [70, 66], [42, 72],
  [55, 78], [28, 74],
];

export const EuropeMap = () => (
  <svg className="europe-map" viewBox="0 0 100 100" role="img" aria-label="Carte de l'Europe">
    {DOTS.map(([x, y], i) => (
      <circle key={`d-${i}`} cx={x} cy={y} r="0.9" fill="rgba(255,255,255,0.35)" />
    ))}
    {MARKERS.map(([x, y], i) => (
      <g key={`m-${i}`} transform={`translate(${x} ${y}) scale(0.13)`} fill="#fff">
        <path d="M12 0C6.5 0 2 4.5 2 10c0 7.5 10 20 10 20s10-12.5 10-20C22 4.5 17.5 0 12 0z" />
        <circle cx="12" cy="10" r="4" fill="rgba(224,112,155,0.95)" />
      </g>
    ))}
  </svg>
);

export default EuropeMap;
